export const CLARITY_GOLD = '#E2A33B';
export const CLARITY_GOLD_TEXT = '#9A6A1E';

export const FONT_DISPLAY = '"Sora", sans-serif';
export const FONT_MONO = '"IBM Plex Mono", monospace';